import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-asistente-direccion-form',
  templateUrl: './asistente-direccion-form.component.html',
  styleUrls: ['./asistente-direccion-form.component.css']
})
export class AsistenteDireccionFormComponent implements OnInit {

  public titulo: string;
  
  via: string;
  numeroVia: string;
  numero: string;
  numero2: string;
  interior: string = '';
  numeroInterior: string = '';
  tipoInterior: string = '';
  numeroTipoInterior: string = '';

  onCerrar: Subject<string>;

  constructor(public bsModalRefAsistenteDireccion: BsModalRef) { }

  ngOnInit() {
    this.onCerrar = new Subject();
  }

  guardar() {
    let direccion = `${this.via} ${this.numeroVia} ${this.numero} ${this.numero2} ${this.interior} ${this.numeroInterior} ${this.tipoInterior} ${this.numeroTipoInterior}`;
    this.onCerrar.next(direccion);
    this.bsModalRefAsistenteDireccion.hide();
  }

}
